<template>
  <div class="panel-simple">
    <template v-if="active">
      <div class="panel-row-without-selector subtitle">
        <div class="tag-badge-referred">
          <span class="dot-info-rev">
            <em class="fas fa-plus orange-icon" />
          </span>
          <span class="tag-badge-title-info">Añadir Documento</span>
        </div>
      </div>

      <div class="container-fluid bg-rectangle-gradiant" />

      <ValidationObserver ref="AddValidationObserver" v-slot="{ passes }">
        <div class="panel-row-without-selector pb-5 col-12">
          <div v-if="fieldMustBeShow('type')" class="col-md-3 info">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <CustomDropDown
                v-model="model.type"
                label="Tipo:"
                placeholder="Seleccione"
                required="required"
                fieldkey="id"
                fieldname="name"
                :options="documentTypes"
                :error="errors[0]"
                custom-error-msg="Favor de seleccionar el tipo de documento."
              />
            </ValidationProvider>
          </div>

          <div v-if="fieldMustBeShow('file')" class="col-md-6 info">
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100"
              name="Documento"
              rules="required"
            >
              <CustomFileInput
                v-model="model.file"
                label="Documento:"
                display-style="normal"
                label-position="left"
                :accept="allowedFiles"
                :error="errors[0]"
                custom-error-msg="Favor de anejar el documento."
              />
            </ValidationProvider>
          </div>
          <div class="col p-0 buttons-container justify-content-end d-flex">
            <ActionButton
              variant="outline-danger mr-2"
              i="fas fa-times-circle"
              @click="cancel"
            >
              Cancelar
            </ActionButton>
            <ActionButton
              variant="success"
              i="fas fa-file-plus"
              @click="passes(add)"
            >
              Añadir
            </ActionButton>
          </div>
        </div>
      </ValidationObserver>
    </template>

    <template v-else>
      <div class="panel-row-without-selector mb-4 pb-4">
        <div class="col-12 text-center">
          <button class="btn bg-light-white w-75 pt-1" @click="active = true">
            <em class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aquí para anejar documento
            </span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomFileInput from '@/components/common/CustomFileInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alert from '@/mixin/alert.mixin';
import CustomDropDown from '@/components/common/CustomDropDown';
const initialState = {
  type: null,
  file: null,
};

export default {
  name: 'LazyAddDocument',
  props: {
    fields: {
      type: Array,
      required: true,
    },
    documentTypes: {
      type: Array,
      required: true,
    },
    addedDocumentTypeIds: {
      type: Array,
      default: () => [],
      required: true,
    },
    preventDuplicatedTypes: {
      type: Array,
      default: () => [],
      required: true,
    },
    allowedFiles: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    model: { ...initialState },
    active: false,
  }),
  methods: {
    fieldMustBeShow(name) {
      if (!this.fields.length) {
        return false;
      }
      const field = this.fields.find((field) => field.name === name);
      return field && field.active;
    },
    add() {
      const valid = this.validateDuplicatedTypes();
      if (valid) {
        this.$emit('add', { ...this.model });
        this.active = false;
        this.model = { ...initialState };
      }
    },
    cancel() {
      this.active = false;
      this.model = { ...initialState };
      this.$emit('cancel');
    },
    validateDuplicatedTypes() {
      if (!this.preventDuplicatedTypes.length) {
        return true;
      }

      const hasDuplicates =
        this.preventDuplicatedTypes.includes(this.model.type.id) &&
        this.addedDocumentTypeIds.includes(this.model.type.id);

      if (hasDuplicates) {
        this.alertDuplicatedTypes();
      }

      return !hasDuplicates;
    },
    alertDuplicatedTypes() {
      this.ShowToast(
        'Alerta',
        `Ya el formulario cuenta con el documento de tipo ${this.model.type.name}`,
        'error'
      );
    },
  },
  components: {
    ActionButton,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
  },
  mixins: [alert],
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped src="@/assets/css/component/badge.css"></style>
<style scoped src="@/assets/css/component/textarea.css"></style>
<style scoped>
.orange-icon {
  color: #ff7058;
}

.hidden {
  display: none;
}

.p-title {
  text-align: left;
  font-family: 'Lato';
  font-size: 16px;
}

.p-title.title-header {
  font-weight: bold;
}

.info > .center-box {
  float: left;
}

.danger-text {
  color: #e85c5c;
}

.actions {
  margin-top: 6rem !important;
}
.buttons-container {
  margin-top: 29px;
}
</style>
